import { Component, Input, OnInit, Optional, Self } from '@angular/core';
import { NgControl } from '@angular/forms';
import { FormControlBase } from '../../common/form-control-base/form-control-base';
import { TranslationProvider } from '../../common/translation-provider';

@Component({
    selector: 'waf-boolean-input',
    templateUrl: './boolean-input.component.html',
    styleUrls: ['./boolean-input.component.scss'],
    standalone: false
})
export class BooleanInputComponent  extends FormControlBase<boolean> {

  @Input()
     public allowNull: boolean = false;

     @Input()
     public useButtons: boolean = false;

     @Input()
     public trueText: string;

     @Input()
     public falseText: string;

     @Input()
     public nullText: string;

     @Input()
     public controlIndicatorClass: string = 'checkbox-control-indicator';

     constructor(
         @Self() @Optional() protected override ngModel: NgControl,
         private translationProvider: TranslationProvider
     ) {
         super('waf-boolean-input', ngModel);

         
         const translations = this.translationProvider.getBooleanInputTranslations();
         this.trueText = this.trueText || translations.Yes;
         this.falseText = this.falseText || translations.No;
         this.nullText = this.nullText || translations.Either;
     }

     onClick() {
         this.value = !this.value;
     }

}
